import {Link} from "react-router-dom";
import PropTypes from 'prop-types';
import {Aux, BASE_URL, IsNullOrUndefined} from "../../constants";
import React from "react";
import AutoFocusTextInput from "../Common/AutoFocusTextInput";
import './TankInput.css';

const TankInput = (props) => {
    let {pickup, run, tankId, isEditMode, onInputTank,
        handleFocus, onPickupTank, isAdmin,
        isWeighing, weighingTankId,
        isCollectionRun, latestReceipt, onOpenReceiptModal, onOpenCollectionReceiptModal} = props;
    let tanks = pickup.pickupTanks;

    if(!run.isBaseCheckedIn || (run.isComplete && !isAdmin) ){
        return null;
    } else {
        return (tanks.map(tank => {

            let isSelectedTank = tankId === tank.tankID;
            let isDisabled = !isEditMode;
            if (!isSelectedTank && tankId > 0) {
                isDisabled = true;
            }
            
            let isDropOff = tank.requiresDropOff;
            let isPickup = tank.requiresPickup || tank.isPickedUp;            
            
            let isWeighingThisTank = weighingTankId === tank.tankID && isWeighing;
            const showLastReceipt = !isDisabled && !isCollectionRun && latestReceipt
                && latestReceipt.pickupId === pickup.id
                && latestReceipt.tankId === tank.tankID;
            
            return (
                <div key={tank.id} className={"mb-2 mt-2"}>
                    { isDropOff && <div className="row">
                        <div className="col-12">
                            <h4 className={`text-${tank.driverEstimatedLitresPickedUp > 0 ? 'success': 'danger'}`}>
                                <i
                                    className={"fa fa-plus-square text-danger mr-1"}
                                    data-toggle="tooltip" data-placement="top" title="Pickup this tank"
                                />#{tank.tankID} drop off</h4>
                        </div>
                    </div> }
                    { isPickup && <div className="row">
                        <div className="col-12">
                            <h4 className={`text-${tank.isPickedUp ? 'success': 'danger'}`}>
                                <i
                                    className={"fa fa-minus-square text-danger mr-1"}
                                    data-toggle="tooltip" data-placement="top" title="Drop off this tank"
                                />#{tank.tankID} {tank.isPickedUp ? 'picked up': 'pickup'}
                                { !isDisabled && <strong> - Picked up? </strong>}
                                { !isDisabled && <label className="switch switch-3d switch-danger">
                                    <input type="checkbox"
                                           checked={tank.isPickedUp}
                                           className="switch-input"
                                           disabled={!IsNullOrUndefined(tank.driverEstimatedLitresPickedUpModified) && tank.isPickedUp}
                                           onChange={(e) => onPickupTank(e, tank.id)}
                                    />
                                    <span className="switch-label" />
                                    <span className="switch-handle" />
                                </label> }
                            </h4>
                        </div>
                    </div> }
                    
                    <div className="row form-group form-inline">
                        <div className="col-12 input-group tank-input-group">
                            {(tank.latitude !== null && tank.longitude !== null) ?
                                <a className="input-group-addon"
                                   href={`http://maps.google.com/maps?&z=21&q=${tank.latitude}+${tank.longitude}`}
                                   target={'_blank'}>{`#${tank.tankID} - ${tank.tankCapacityLitres}L`}</a> :
                                <span
                                    className="input-group-addon">{`#${tank.tankID} - ${tank.tankCapacityLitres}L`}</span>}
                            {!isWeighingThisTank && (isSelectedTank ?
                                <AutoFocusTextInput  
                                    className="form-control"
                                    type="number"
                                    disabled={isDisabled}
                                    onChange={(e) => onInputTank(e, tank.id)}
                                    placeholder="Picked up"
                                    value={tank.driverEstimatedLitresPickedUp == null ? 0 : tank.driverEstimatedLitresPickedUp}
                                    onFocus={handleFocus}
                                    style={{lineHeight: '3em', fontSize: 'large'}}
                                /> :
                                <input
                                    className="form-control"
                                    type="number"
                                    disabled={isDisabled}
                                    onChange={(e) => onInputTank(e, tank.id)}
                                    placeholder="Picked up"
                                    value={tank.driverEstimatedLitresPickedUp == null ? 0 : tank.driverEstimatedLitresPickedUp}
                                    onFocus={handleFocus}
                                    style={{lineHeight: '3em', fontSize: 'large'}}
                                />) }
                            {isWeighingThisTank &&
                                <input
                                    className="form-control"
                                    type="number"
                                    disabled={true}
                                    placeholder="Picked up"
                                    value={latestReceipt?.tankId === tank.tankID ? latestReceipt.deliveryTotal : tank.driverEstimatedLitresPickedUp || 0}
                                    onFocus={handleFocus}
                                    style={{lineHeight: '3em', fontSize: 'large'}}
                                />
                            }
                            
                            {isDisabled && <Link className="input-group-addon" style={{float: 'right'}}
                                                 to={`${BASE_URL}/qr/lookuprun/?runId=${pickup.runId}&pickupId=${pickup.id}&pickupTankId=${tank.id}&action=startPickup`}
                                                 activeClassName="active"><i
                                className="fa fa-3x fa-qrcode"/></Link>}

                            {/* Receipt indicator for delivery runs */}
                            {showLastReceipt &&
                                ( <span className="input-group-addon">
                                    <span className="badge badge-success" style={{fontSize: '1em', padding: '0.5em'}}>
                                        <i className="fa fa-file-text-o"/> {latestReceipt.deliveryTotal}L
                                    </span>
                                </span>)
                            }

                            {/* Select collection (weight) receipts to add to this tank's running total */}
                            {!isDisabled && isCollectionRun && !isWeighingThisTank && onOpenCollectionReceiptModal &&
                                <span className="input-group-addon tank-action-addon">
                                    <button className="btn btn-info" onClick={() => onOpenCollectionReceiptModal(tank)}>
                                        <i className="fa fa-balance-scale fa-2x"/> Receipts
                                    </button>
                                </span>
                            }

                            {/* Select a receipt to autofill this tank (delivery runs) */}
                            {!isDisabled && !isCollectionRun && !isWeighingThisTank && onOpenReceiptModal &&
                                <span className="input-group-addon tank-action-addon">
                                    <button className="btn btn-info" onClick={() => onOpenReceiptModal(tank)}>
                                        <i className="fa fa-file-text-o fa-2x"/> Receipt
                                    </button>
                                </span>
                            }

                            {/* Start/End Pumping removed — drivers now select a receipt (above) as the
                                primary mechanism; receipts arrive and are picked in realtime. */}
                        </div>
                    </div>
                    
                </div>
            );
        }));
    }
};

TankInput.propTypes = {
    onBeginDelivery: PropTypes.func,
    onEndDelivery: PropTypes.func,
    isWeighing: PropTypes.bool,
    weighingTankId: PropTypes.number,
    isCollectionRun: PropTypes.bool,
    latestReceipt: PropTypes.object,
    onOpenReceiptModal: PropTypes.func,
    onOpenCollectionReceiptModal: PropTypes.func,
};

TankInput.defaultProps = {
    isCollectionRun: true,
    latestReceipt: null,
};

export default TankInput;